import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "Unassigned_Visits",
  class: "dashboard-card d-flex"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Unassigned Visits (Next 7 Days)")
], -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "mt-3 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Loading your unassigned visit count", -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-spinner fa-pulse fa-fw" }, null, -1 /* HOISTED */)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "mt-5 text-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" There was a problem while fetching your unassigned visit count. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please try again. ")
], -1 /* HOISTED */)
const _hoisted_10 = {
  key: 2,
  class: "no-data"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "mb-3" }, " Good Job! There were no unassigned visit count. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "h-100 overflow-auto position-relative w-100 d-flex align-items-center p-2 active-patients" }
const _hoisted_14 = { class: "legend ms-4" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", { class: "ps-3" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", { class: "ps-2" }, null, -1 /* HOISTED */)
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!
  const _component_CardTemplate = _resolveComponent("CardTemplate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardTemplate, null, {
      header: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_7))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" ERROR "),
        (_ctx.hasError && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getVisitCount()))
              }, "Try Again")
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" NO DATA "),
        (_ctx.visitCounts.length === 0 && !_ctx.isLoading && !_ctx.hasError)
          ? (_openBlock(), _createElementBlock("section", _hoisted_10, _hoisted_12))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" DATA "),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Chart, {
            type: "pie",
            data: _ctx.chartData,
            options: _ctx.chartOptions
          }, null, 8 /* PROPS */, ["data", "options"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("table", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitCounts, (visit) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: visit.Application,
                  class: _normalizeClass(
                                    _ctx.ApplicationNamesEnum.getDescriptionUsingValue(visit.Application) == _ctx.active.label
                                        ? _ctx.getProductColorClass(_ctx.active.label)
                                        : 'text-black'
                                )
                }, [
                  (visit.Application !== _ctx.ApplicationEnum.AgencyCore)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.ApplicationNamesEnum.getDescriptionUsingValue(visit.Application)), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  _hoisted_16,
                  _hoisted_17,
                  (visit.Application !== _ctx.ApplicationEnum.AgencyCore)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "javascript:void(0);",
                        onClick: ($event: any) => (_ctx.redirectToUnassignedVisit(visit.Application)),
                        class: "no-tag-color"
                      }, [
                        _createElementVNode("td", null, _toDisplayString(visit.Counts.UnassignedVisitCount), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_18))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}